import { LogLevel } from '@azure/msal-browser';
import { B2C_POLICIES } from 'config/constants';
import posthog from 'posthog-js';

export const VALIDATE_EMAIL_REGEX = /\S+@\S+\.\S+/;

export const userHasPermission = (roles: string[], permissions?: string[]): boolean => {
  let hasRole = false;
  roles.forEach((item) => {
    if (permissions && permissions.indexOf(item) > -1) {
      hasRole = true;
    }
  });
  return hasRole;
};

export const MSAL_CONFIG = (email?: string, domainHint?: string) => {
  return {
    msal: {
      auth: {
        clientId: import.meta.env.VITE_CLIENT_ID_B2C as string,
        authority: B2C_POLICIES.authorities.signUpSignIn.authority,
        knownAuthorities: [B2C_POLICIES.authorityDomain],
        redirectUri: `${window.location.origin}/redirectB2C`,
        postLogoutRedirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: 'localStorage',
      },
      system: {
        loggerOptions: {
          loggerCallback: (level: LogLevel, message: string, containsPii: unknown) => {
            if (level === LogLevel.Error) {
              posthog?.capture('LOGIN_ERROR', { message, email, domainHint });
            }
          },
        },
      },
    },
    login: {
      scopes: [
        `https://${import.meta.env.VITE_AUTH_TENANT}.onmicrosoft.com/shape-auth/pm.service.read`,
        `https://${import.meta.env.VITE_AUTH_TENANT}.onmicrosoft.com/shape-auth/pm.service.write`,
        `https://${
          import.meta.env.VITE_AUTH_TENANT
        }.onmicrosoft.com/shape-auth/pm.filemanager.read`,
        `https://${
          import.meta.env.VITE_AUTH_TENANT
        }.onmicrosoft.com/shape-auth/pm.filemanager.write`,
      ],
      loginHint: email || '',
      extraQueryParameters: { domain_hint: domainHint || '' },
    },
  };
};
